export const isValidUrl = (url: string | undefined): boolean =>
  typeof url === 'string' && url.length > 0
